import {
  Box, Button, Flex, Grid, Heading, Image, Stack, Text,
  Badge, useColorModeValue, useToast,
} from '@chakra-ui/react'
import { DownloadIcon } from '@chakra-ui/icons'
import Card from 'components/Card/Card'
import CardBody from 'components/Card/CardBody'
import CardHeader from 'components/Card/CardHeader'
import { SearchBar } from 'components/Navbars/SearchBar/SearchBar'
import Cookies from 'js-cookie'
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { GET_WORKSHEETS_BY_USER_ID } from 'store/worksheets'
import api from 'store/api'

import eng from 'assets/img/5.png'
import mathPost from 'assets/img/1.png'
import mathPre from 'assets/img/2.png'
import sciPost from 'assets/img/3.png'
import sciPre from 'assets/img/4.png'
import social from 'assets/img/6.png'
import thai from 'assets/img/7.png'

const imageSubject = (subject, classNum) => {
  const num = classNum && classNum.split(' ')[1]
  if (subject === 'คณิตศาสตร์' && num < 4) return mathPre
  if (subject === 'คณิตศาสตร์' && num >= 4) return mathPost
  if (subject === 'วิทยาศาสตร์' && num < 4) return sciPre
  if (subject === 'วิทยาศาสตร์' && num >= 4) return sciPost
  if (subject === 'สังคมศึกษา') return social
  if (subject === 'ภาษาอังกฤษ') return eng
  if (subject === 'ภาษาไทย') return thai
}

const WorksheetCard = ({ worksheet }) => {
  const textColor = useColorModeValue('gray.700', 'white')
  const toast = useToast()
  const [downloading, setDownloading] = useState(false)

  const handleDownload = async () => {
    setDownloading(true)
    try {
      const response = await api.downloadWorksheet(worksheet.worksheet_id)
      const blob = new Blob([response.data], { type: 'application/pdf' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `${worksheet.worksheet_name || 'worksheet'}.pdf`
      link.click()
      window.URL.revokeObjectURL(url)
    } catch (err) {
      toast({
        title: 'ดาวน์โหลดไม่สำเร็จ',
        description: err.response?.status === 403 ? 'ไม่มีสิทธิ์เข้าถึงใบงานนี้' : 'เกิดข้อผิดพลาด',
        status: 'error',
        duration: 4000,
        isClosable: true,
      })
    } finally {
      setDownloading(false)
    }
  }

  return (
    <Flex direction='column'>
      <Box mb='20px' position='relative' borderRadius='15px' overflow='hidden'>
        <Image
          w='full'
          objectFit='cover'
          src={worksheet.url_image || imageSubject(worksheet.subject, worksheet.class)}
          borderRadius='15px'
        />
      </Box>
      <Flex direction='column'>
        <Text fontSize='md' color='gray.500' fontWeight='600' mb='6px'>
          {worksheet.subject} {worksheet.class}
        </Text>
        <Text fontSize='xl' color={textColor} fontWeight='bold' mb='8px' noOfLines={2}>
          {worksheet.worksheet_name}
        </Text>
        <Text fontSize='md' color='gray.500' mb='16px' noOfLines={3}>
          {worksheet.worksheet_description}
        </Text>
        <Badge colorScheme={worksheet.is_free ? 'green' : 'teal'} w='fit-content' mb='12px'>
          {worksheet.is_free ? 'ฟรี' : 'ซื้อแล้ว'}
        </Badge>
        <Button
          colorScheme='teal'
          leftIcon={<DownloadIcon />}
          size='sm'
          onClick={handleDownload}
          isLoading={downloading}
          loadingText='กำลังดาวน์โหลด...'
        >
          ดาวน์โหลด PDF
        </Button>
      </Flex>
    </Flex>
  )
}

function MyWorksheet() {
  const dispatch = useDispatch()
  const [searching, setSearching] = useState(false)

  const initFetch = useCallback(() => {
    dispatch(GET_WORKSHEETS_BY_USER_ID(Cookies.get('user_id')))
  }, [dispatch])

  useEffect(() => { initFetch() }, [initFetch])

  const lists = useSelector((state) => state.worksheets.listsUser)

  const fetchData = useCallback((searchInput) => {
    setSearching(true)
    dispatch(GET_WORKSHEETS_BY_USER_ID(`${Cookies.get('user_id')}`))
  }, [dispatch])

  const activeWorksheets = (lists || []).filter(w => w.worksheet_status)

  if (activeWorksheets.length === 0 && !searching) {
    return (
      <Flex direction='column' pt={{ base: '80px', md: '75px' }}>
        <Card p='16px' my='24px'>
          <CardBody px='5px'>
            <Text>ไม่มีใบงานที่สมัคร</Text>
          </CardBody>
        </Card>
      </Flex>
    )
  }

  return (
    <Flex direction='column' pt={{ base: '80px', md: '75px' }}>
      <Card p='16px' my='24px'>
        <CardHeader mb='1rem'>
          <Heading size='md'>ใบงานของฉัน</Heading>
        </CardHeader>
        <CardBody px='5px'>
          <Grid
            templateColumns={{ sm: '1fr', md: '1fr 1fr', xl: 'repeat(4, 1fr)' }}
            templateRows={{ sm: '1fr 1fr 1fr auto', md: '1fr 1fr', xl: '1fr' }}
            gap='24px'
          >
            {activeWorksheets.map((item) => (
              <WorksheetCard key={item.worksheet_id} worksheet={item} />
            ))}
          </Grid>
        </CardBody>
      </Card>
    </Flex>
  )
}

export default MyWorksheet
